import { stats, testimonials } from '@/mocks/site';

export default function Voices() {
  return (
    <section className="bg-background-50" id="voices">
      <div className="mx-auto max-w-content px-4 md:px-8 py-14 md:py-20">
        <div className="rounded-lg bg-secondary-900 px-6 py-10 md:px-10 md:py-12">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
            {stats.map((item) => (
              <div key={item.label}>
                <p className="font-heading text-3xl md:text-4xl font-black text-accent-300">
                  {item.value}
                </p>
                <p className="mt-2 text-sm font-medium text-background-50">{item.label}</p>
                <p className="mt-1 text-xs text-secondary-300 leading-relaxed">{item.note}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-12 md:mt-16">
          <div className="mb-8">
            <p className="text-xs tracking-[0.3em] text-secondary-600 font-label">VOICES</p>
            <h2 className="mt-3 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              读者怎么说
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
            {testimonials.map((item) => (
              <figure
                key={item.name}
                className="flex flex-col bg-background-100 border border-background-200 rounded-lg p-5"
              >
                <i className="ri-double-quotes-l text-2xl text-primary-300" aria-hidden="true" />
                <blockquote className="mt-3 text-sm leading-relaxed text-foreground-700 flex-1">
                  {item.text}
                </blockquote>
                <figcaption className="mt-4 pt-4 border-t border-background-200">
                  <span className="block text-sm font-medium text-foreground-900">{item.name}</span>
                  <span className="block text-xs text-foreground-500 mt-0.5">{item.role}</span>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}